import React from "react";
import { SHr, SNavigation, SPage, SText, STheme, SView } from "servisofts-component2";
import Input from "../../Components/Input";
import MDL from "../../MDL";
import CryptoJS from 'crypto-js';
import Config from "../../Config";
import HTTP from "../../HTTP";

const ADMIN_LOGIN_TAG_STYLE = "color:#22c55e;font-weight:700";
const ADMIN_LOGIN_MSG_STYLE = "color:#38bdf8;font-weight:600";

const logAdminLogin = (message, data) => {
    if (typeof data === "undefined") {
        console.log("%c[admin/login]%c " + message, ADMIN_LOGIN_TAG_STYLE, ADMIN_LOGIN_MSG_STYLE);
        return;
    }
    console.log("%c[admin/login]%c " + message, ADMIN_LOGIN_TAG_STYLE, ADMIN_LOGIN_MSG_STYLE, data);
};

export default class index extends React.Component {
    state = { error: "" }
    inp_usuario = null;
    inp_contraseña = null;
    componentDidMount() {
        if (MDL.usuario.session) {
            SNavigation.replace("/");
            return;
        }
    }
    async onSave() {
        logAdminLogin("onSave:start");
        let usuario = this.inp_usuario.getValue();
        let password = this.inp_contraseña.getValue();
        logAdminLogin("credentials", {
            usuario,
            hasPassword: !!password,
        });
        if (!usuario || !password) {
            logAdminLogin("missing fields");
            this.setState({ error: "Debes completar todos los campos." });
            return;
        }
        try {
            logAdminLogin("hashing password");
            password = CryptoJS.MD5(password).toString();
            logAdminLogin("request payload", {
                url: Config.apis.usuario + "/usuario/login",
                username: usuario,
            });
            const response = await HTTP.POST({
                url: Config.apis.usuario + "/usuario/login",
                body: {
                    username: usuario,
                    password: password
                }
            });
            logAdminLogin("response", response);
            // await this.setSession(response);
            this.setState({ error: "" });
            response.type = "admin";
            logAdminLogin("session response before save", response);
            MDL.usuario.setSession(response);
            logAdminLogin("session saved, navigating to /admin");
            SNavigation.replace("/admin");
            // SNavigation.replace("/")
            // return user;
        } catch (error) {
            // console.error("%c[admin/login]%c login error", ADMIN_LOGIN_TAG_STYLE, "color:#ef4444;font-weight:700", error);
            this.setState({ error: error?.message });
        }
    }
    render() {
        return <SPage title={""}>
            <SView col={"xs-12"} flex style={{ minHeight: "100%",  backgroundColor: STheme.color.primary, overflow: "hidden", paddingHorizontal: 16,}}>
                <SHr h={16}/>
                <SView
                    style={{ width: "100%", maxWidth: 440, alignSelf: "center", backgroundColor: STheme.color.primary, paddingHorizontal: 22, paddingVertical: 28, borderRadius: 22, borderWidth: 1, borderColor: STheme.color.card, shadowColor: STheme.color.primary, shadowOpacity: 0.45, shadowRadius: 20, shadowOffset: { width: 0, height: 10 }, elevation: 10, }}>
                    <SView style={{ alignSelf: "center", backgroundColor: STheme.color.secondary + "22", borderWidth: 1, borderColor: STheme.color.secondary + "66", borderRadius: 999, paddingHorizontal: 12, paddingVertical: 4, marginBottom: 8, }}>
                        <SText style={{ color: STheme.color.secondary, fontSize: 11, fontWeight: "700", letterSpacing: 1 }}>PANEL ADMIN</SText>
                    </SView>
                    <SHr height={18} />
                    <SView center row>
                        <SText center bold color={STheme.color.text} fontSize={30} style={{ letterSpacing: 3, }}>ROR</SText><SText center bold color={STheme.color.secondary} fontSize={30} style={{ paddingLeft: 4, letterSpacing: 3, }}>GPS</SText>
                    </SView>
                    <SHr height={12} />
                    <SText center bold color={STheme.color.text} fontSize={22}>Administrador</SText>
                    <SHr height={4} />
                    <SText center color={STheme.color.lightGray} fontSize={17}>Inicia sesión para continuar</SText>
                    <SHr height={24} />
                    <SView border={"transparent"}>
                        <SText bold style={{ color: STheme.color.text, fontSize: 14, letterSpacing: 0.3, marginBottom: 4, }}>Usuario</SText>
                        <SView style={{ height: 54 }}>
                            <Input
                                type="text"
                                ref={ref => this.inp_usuario = ref}
                                style={{ width: "100%", height: 54, paddingHorizontal: 16, borderRadius: 13, backgroundColor: STheme.color.card, color: STheme.color.text, fontSize: 18, }}
                                placeholder="correo@empresa.com"
                                // defaultValue="rickypazd@icloud.com"
                                autoCapitalize="none"
                                keyboardType="email-address"
                            />
                        </SView>
                    </SView>
                    <SHr height={24} />
                    <SView border={"transparent"}>
                        <SText bold style={{ color: STheme.color.text, fontSize: 14, letterSpacing: 0.3, marginBottom: 4, }}>Contraseña</SText>
                        <SView style={{ height: 54 }}>
                            <Input
                                type="password"
                                ref={ref => this.inp_contraseña = ref}
                                style={{ width: "100%", height: 54, paddingHorizontal: 16, borderRadius: 13, backgroundColor: STheme.color.card, color: STheme.color.text, fontSize: 18, }}
                                placeholder="••••••••"
                                // defaultValue="123"
                                autoCapitalize="none"
                                keyboardType="default"
                            />
                        </SView>
                        {this.state.error && (
                            <SView style={{ alignItems: "center", position: "absolute", marginTop: 84, alignSelf: "center", width: "100%", paddingHorizontal: 12 }}>
                                <SText color={STheme.color.danger} center fontSize={13}>{this.state.error}</SText>
                            </SView>
                        )}
                    </SView>
                    <SHr height={40} />
                    <SView
                        // onPress={() => { SNavigation.replace("/admin"); }}
                        // TODO: RICKY TIENE QUE VERLO
                        onPress={() => this.onSave()}
                        style={{
                            width: "100%",
                            height: 56,
                            borderRadius: 14,
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundColor: STheme.color.secondary,
                            shadowColor: STheme.color.secondary,
                            shadowOpacity: 0.35,
                            shadowRadius: 12,
                            shadowOffset: { width: 0, height: 6 },
                            elevation: 6,
                        }}
>
                        <SText bold style={{ color: STheme.color.primary, fontSize: 28, letterSpacing: 0.3 }}> Iniciar sesión </SText>
                    </SView>
                    <SView style={{ marginTop: 18, alignItems: "center", }}><SText style={{ color: STheme.color.lightGray, fontSize: 14, }}>¿Olvidaste tu contraseña?</SText></SView>
                </SView>
            </SView>
        </SPage>
    }
}